/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Bestätigen`
};

const en_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirm`
};

const es_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar`
};

const fr_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmer`
};

const it_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Conferma`
};

const nl_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Bevestigen`
};

const pt_action__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__validate = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__validate(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__validate", locale)
	if (locale === "de") return de_action__validate(inputs)
	if (locale === "en") return en_action__validate(inputs)
	if (locale === "es") return es_action__validate(inputs)
	if (locale === "fr") return fr_action__validate(inputs)
	if (locale === "it") return it_action__validate(inputs)
	if (locale === "nl") return nl_action__validate(inputs)
	return pt_action__validate(inputs)
};